import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  CompanyProfile, CompanyAlterPic, CompanyContract, CompanyFinance, reportClasses, Pnfam, CompanyAlterPassword,
} from '../screens/enterprise';

const Profile = createStackNavigator();
const ProfileCompany = () => (
  <Profile.Navigator screenOptions={screenOptions}>
    <Profile.Screen name="Company Profile" component={CompanyProfile} />
    <Profile.Screen name="Company Alter Pic" component={CompanyAlterPic} />
    <Profile.Screen name="Company Alter Password" component={CompanyAlterPassword} />

    <Profile.Screen name="Company Contract" component={CompanyContract} />
    <Profile.Screen name="Company Finance" component={CompanyFinance} />
    <Profile.Screen name="Company Report Classes" component={reportClasses} />
    <Profile.Screen name="Company Pnfam" component={Pnfam} />

  </Profile.Navigator>
);

export default ProfileCompany;
